import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Users, EnvelopeSimple, Lightning, Key, Robot, CalendarBlank } from "@phosphor-icons/react";
import { AdminShell } from "@/components/AdminShell";
import api, { errDetail } from "@/lib/api";

export default function AdminStats() {
  const [stats, setStats] = useState(null);
  const [ready, setReady] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch((e) => toast.error(errDetail(e)));
    api.get("/admin/production-readiness").then((r) => setReady(r.data)).catch(() => {});
  }, []);

  const cards = stats ? [
    ["Users", stats.users, Users], ["Emails stored", stats.emails, EnvelopeSimple], ["Rules", stats.rules, Lightning],
    ["API keys", stats.api_keys, Key], ["Agent messages", stats.agent_messages, Robot], ["Calendar events", stats.calendar_events, CalendarBlank],
  ] : [];

  return (
    <AdminShell title="Platform Stats" subtitle="Live usage numbers across the whole platform." testId="admin-stats-page">
      {ready && (
        <div data-testid="readiness-card" className={`border rounded-md p-4 mb-4 ${ready.passed === ready.total ? "border-emerald-200 bg-emerald-50/50" : "border-amber-200 bg-amber-50/50"}`}>
          <div className="font-heading font-bold text-gray-900 mb-1.5">Production readiness {ready.passed}/{ready.total}</div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
            {Object.entries(ready.checks).map(([k, v]) => (
              <span key={k} data-testid={`readiness-${k}`} className={v ? "text-emerald-700" : "text-amber-700 font-semibold"}>{v ? "✅" : "⚠"} {k.replaceAll("_", " ")}</span>
            ))}
          </div>
        </div>
      )}
      {!stats ? <p className="text-sm text-gray-400">Loading…</p> : (
        <div className="grid grid-cols-3 gap-3">
          {cards.map(([l, v, I]) => (
            <div key={l} data-testid={`stat-${l}`} className="border border-gray-200 rounded-md p-4">
              <I size={18} className="text-blue-600 mb-2" />
              <div className="font-heading text-2xl font-bold text-gray-900">{v}</div>
              <div className="text-xs text-gray-500">{l}</div>
            </div>
          ))}
        </div>
      )}
    </AdminShell>
  );
}
